<div class="row downloads-links">
  <div class="col-12 col-lg-6 to-do pt-0 pb-0 pt-md-4 pb-md-5">
    <h4 class="text-black mb-4">DOWNLOADS</h4>
    <div [innerHTML]="downloads.content"></div>
  </div>
</div>